<template>
  <vs-popup :active.sync="KbActive" title="">
    <div class="vx-row">
      <div class="vx-col w-full mt-2">
        <label for="title">Title</label>
        <vs-input class="w-full" v-model="data.title"></vs-input>
      </div>
      <div class="vx-col w-full mt-2">
        <label for="title">Description</label>
        <vs-textarea class="w-full" v-model="data.description"></vs-textarea>
      </div>
      <div class="vx-col w-full mt-2">
        <label for="image">Image</label>
        <input type="file" @change="getImage" />
      </div>
      <div class="vx-col w-full mt-2 flex justify-end">
        <vs-button color="success" @click="editKnowledgeBase"
          >{{ $t('save') }}</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>
<script>
import { updateKnowledgeBase } from "../../../../api/knowledgebase";
export default {
  name: "EditKnowledgeBase",
  props: {
    editActive: {
      required: true,
      type: Boolean
    },
    editData: {
      type: Object
    }
  },
  data: () => ({
    data: {
      id: null,
      title: "",
      description: ""
    },
    image: null
  }),
  computed: {
    KbActive: {
      get() {
        return this.$props.editActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeEditKb");
        }
      }
    }
  },
  watch: {
    editData(val) {
      var a = new Object();
      this.$data.data = new Object();
      Object.assign(a, val);
      this.$data.data = a;
    }
  },
  methods: {
    getImage(e) {
      this.image = e.target.files[0];
    },
    editKnowledgeBase() {
      var d = new FormData();
      d.append("id", this.data.id);
      d.append("title", this.data.title);
      d.append("description", this.data.description);
      if (this.image) {
        d.append("photo", this.image);
      }
      // Object.assign(d,{title:this.data.title,description:this.data.description,id:this.data.id});
      updateKnowledgeBase(d).then(res => {
        this.$emit("getUpdateKb", res.data);
      });
    }
  }
};
</script>
<style scoped></style>
